import type { BenLanguageBackendCode } from '@ben/common/languages';
import MantineRichTextEditor, {
  HeadingLevel,
} from '@ben/orion/mantine-rich-text-editor';
import { useUploadRichTextImage } from '@ben/shared/hooks/use-upload-rich-text-image';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import type { ToolName } from '@ben/columbia/components/assistant/types';
import AIToolWrapper from '../../assistant/ai-tool-wrapper';
import { fieldCannotBeBlankErrorMessage } from '../../shared/constants';

const CONTENT_HEADINGS = [
  HeadingLevel.H2,
  HeadingLevel.H3,
  HeadingLevel.H4,
  HeadingLevel.H5,
  HeadingLevel.H6,
];

interface ContentProps {
  language: BenLanguageBackendCode;
  errors: Record<string, boolean>;
  controlName?: string;
}

const Content = ({ language, errors, controlName }: ContentProps) => {
  const { control } = useFormContext();
  const employerId = useWatch({ control, name: 'employer', exact: true });
  const name = controlName ? `${controlName}${language}` : `content${language}`;
  const { uploadImage } = useUploadRichTextImage({ employerId });

  return (
    <AIToolWrapper fieldName={name} toolName={name as ToolName}>
      <Controller
        control={control}
        name={name}
        render={({ field, fieldState }) => (
          <MantineRichTextEditor
            label={name}
            value={field.value}
            onChange={field.onChange}
            errorMessage={
              fieldState.error || errors?.[name]
                ? fieldState.error?.message || fieldCannotBeBlankErrorMessage
                : undefined
            }
            onImageUpload={uploadImage}
            imagePasteEnabled={!!employerId}
            iframeEnabled
            headings={CONTENT_HEADINGS}
            tableEnabled
          />
        )}
      />
    </AIToolWrapper>
  );
};

export default Content;
